'use client'

import type { PriceProps } from '@maestro/commerce-blocks/components/price/price.types'

import classNames from 'classnames'

import { usePrice } from '@maestro/commerce-blocks/components/price/batons/use-price'

import '@maestro/commerce-blocks/components/price/styles/price.scss'

export default function Price(props: PriceProps) {
  const {
    isPriceVisible,
    integerPrice,
    decimalPrice,
    prefix,
    suffix,
    isActive,
    isDiscountedPrice,
    isMemberPrice,
    isDecimalSuper,
    isDecimalZero,
    unitLabel,
    taxLabel,
    screenReaderText,
    formattedPrice,
  } = usePrice(props)

  if (!isPriceVisible) {
    return null
  }

  if (formattedPrice) {
    return (
      <span className={classNames('price')}>
        <span className="sr-only">{screenReaderText}</span>

        <span aria-hidden="true" className="price__wrapper">
          <span className="price-formatted">{formattedPrice}</span>
          {!!unitLabel && <span className="price-unit">{unitLabel}</span>}
          {!!taxLabel && (
            <>
              {' '}
              <span className="price__tax-label">{taxLabel}</span>
            </>
          )}
        </span>
      </span>
    )
  }

  return (
    <span
      className={classNames('price', {
        'price--inactive': !isActive,
        'price--member': isMemberPrice,
        'price--new': isDiscountedPrice,
      })}
    >
      <span className="sr-only">{screenReaderText}</span>

      <span aria-hidden="true" className="price__wrapper">
        {!!prefix && <span className="price-prefix">{prefix}</span>}
        <span className="price-int">{integerPrice}</span>
        {!isDecimalZero && !!decimalPrice && (
          <span
            className={classNames('price-decimal', { sup: isDecimalSuper })}
          >
            {decimalPrice}
          </span>
        )}
        {isDecimalZero && !!suffix && (
          <span className="price-suffix">{suffix}</span>
        )}
        {!!unitLabel && <span className="price-unit">{unitLabel}</span>}
        {!!taxLabel && (
          <>
            {' '}
            <span className="price__tax-label">{taxLabel}</span>
          </>
        )}
      </span>
    </span>
  )
}
